import { ActionIcon, Card, Slider } from "@mantine/core";
import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";
import { useAppSelector, useAppDispatch } from "../store/hooks";
import { setGroupedEventsIndex } from "../store";

export const QuantitySlider = ({
  referenceImageCount,
  disableBtns,
}: {
  referenceImageCount: number;
  disableBtns: boolean;
}) => {
  const dispatch = useAppDispatch();
  const groupedEventsIndex = useAppSelector(
    (state) => state.oos.groupedEventsIndex,
  );
  const min = 0;
  const max = referenceImageCount;

  const handleDecrease = () => {
    if (typeof groupedEventsIndex === "number") {
      const newIndex =
        groupedEventsIndex - 1 < 0 ? null : groupedEventsIndex - 1;
      dispatch(setGroupedEventsIndex(newIndex));
    } else {
      dispatch(setGroupedEventsIndex(0));
    }
  };

  const handleIncrease = () => {
    if (typeof groupedEventsIndex === "number") {
      dispatch(setGroupedEventsIndex(groupedEventsIndex + 1));
    } else {
      dispatch(setGroupedEventsIndex(0));
    }
  };

  return (
    <Card
      shadow="lg"
      padding="lg"
      radius="md"
      withBorder
      className="flex-1 mt-2"
    >
      <div className="relative">
        {/* Slider container */}
        <div className="flex items-center gap-4">
          {/* Left button */}
          <ActionIcon
            className="flex items-center justify-center w-10 h-10 bg-blue-500 hover:bg-blue-600 text-white rounded transition-colors"
            aria-label="Decrease"
            onClick={handleDecrease}
            disabled={disableBtns || groupedEventsIndex === null}
            size="xl"
          >
            <IconChevronLeft size={20} />
          </ActionIcon>

          {/* Slider */}
          <div className="flex-1">
            <Slider
              value={
                typeof groupedEventsIndex === "number"
                  ? groupedEventsIndex + 1
                  : 0
              }
              // onChange={setValue}
              showLabelOnHover={false}
              min={min}
              max={max}
              step={1}
              styles={{
                markLabel: {
                  marginTop: "8px",
                  fontSize: "14px",
                  color: "#9ca3af",
                },
              }}
            />
          </div>

          {/* Right button */}
          <ActionIcon
            className="flex items-center justify-center w-10 h-10 bg-blue-500 hover:bg-blue-600 text-white rounded transition-colors"
            aria-label="Increase"
            onClick={handleIncrease}
            disabled={
              disableBtns ||
              groupedEventsIndex === max - 1 ||
              referenceImageCount === 0
            }
            size="xl"
          >
            <IconChevronRight size={20} />
          </ActionIcon>
        </div>
      </div>
    </Card>
  );
};
